import React, { useState } from 'react';
import { faqItems } from '../data/faq';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq-heading" className="bg-white" data-id="element-103" data-mp="1q9kbzbc2dx2v">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 md:py-28" data-id="element-104" data-mp="1lctwoq8335ii">
        <h2 id="faq-heading" className="max-w-[32rem] font-serif text-[30px] font-semibold leading-[1.12] tracking-[-0.015em] text-ink md:text-[44px]" data-id="element-105" data-mp="1gcxo0dofypwm">
          Questions providers ask before buying
        </h2>

        <ul className="mx-auto mt-12 max-w-[46rem] border-t border-brass/30" data-id="element-106" data-mp="291wcdsj5qoad">
          {faqItems.map((item, index) => {
          const isOpen = open === index;
          return <li key={item.question} className="border-b border-brass/30" data-id="element-107" data-mp="1z2duriqpzelh" data-mpi={index}>
                <h3 data-id="element-108" data-mp="snd6lz7xs0pg">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} id={`faq-trigger-${index}`} className="flex w-full items-start justify-between gap-6 py-6 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brass" data-id="element-109" data-mp="snwcuio850nn">
                    <span className="text-[17px] font-semibold leading-[1.45] text-ink" data-id="element-110" data-mp="khjs3ync4lua">
                      {item.question}
                    </span>
                    <span aria-hidden="true" className="mt-[2px] shrink-0 font-mono text-[20px] leading-none text-brass" data-id="element-111" data-mp="bi6hv3rdzt8i">
                      {isOpen ? '–' : '+'}
                    </span>
                  </button>
                </h3>

                {isOpen && <div id={`faq-panel-${index}`} role="region" aria-labelledby={`faq-trigger-${index}`} className="animate-fade pb-7 pr-10" data-id="element-112" data-mp="3jz19to6nbt7t">
                    <p className="max-w-[40rem] text-[16px] font-normal leading-[1.65] text-slate" data-id="element-113" data-mp="1uixl94ro9d6w">
                      {item.answer}
                    </p>
                  </div>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}